"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _cccisdGraphqlTable = _interopRequireDefault(require("cccisd-graphql-table"));
var _cccisdReactRouter = require("cccisd-react-router");
var _Certificate = _interopRequireDefault(require("./Certificate"));
var _LicensingAdminContext = require("../../components/LicensingAdminContext");
var _progress = _interopRequireDefault(require("./progress.graphql"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var Fortress = window.cccisd.fortress;
var Courses = function Courses() {
  if (!Fortress.hasAnyAccess(['licensing.admin', 'licensing.courses'])) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "alert alert-warning"
    }, /*#__PURE__*/_react["default"].createElement("p", null, "You do not have permission to access this page"));
  }
  var licensingAdminContext = (0, _react.useContext)(_LicensingAdminContext.Context);
  var selectedProduct = licensingAdminContext.selectedProduct,
    selectedCourse = licensingAdminContext.selectedCourse,
    selectedDeployment = licensingAdminContext.selectedDeployment;
  var location = (0, _cccisdReactRouter.useLocation)();
  if (!(selectedProduct !== null && selectedProduct !== void 0 && selectedProduct.productId)) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "alert alert-warning"
    }, /*#__PURE__*/_react["default"].createElement("p", null, "There are no Licensed Products. Start by\xA0", /*#__PURE__*/_react["default"].createElement(_cccisdReactRouter.Link, {
      to: location.pathname + '#products'
    }, "creating a new Licensed Product"), " before viewing Course data."));
  }
  if (!(selectedCourse !== null && selectedCourse !== void 0 && selectedCourse.assignmentId)) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "alert alert-warning"
    }, /*#__PURE__*/_react["default"].createElement("p", null, "There are no Courses associated with ", /*#__PURE__*/_react["default"].createElement("b", null, selectedProduct.label), ".", Fortress.hasAnyAccess(['quest.admin', 'quest.design']) && /*#__PURE__*/_react["default"].createElement("span", null, "\xA0You can associate a Quest with a Licensed Product in the", ' ', /*#__PURE__*/_react["default"].createElement(_cccisdReactRouter.Link, {
      to: "/quest"
    }, "Quest"), " area.")));
  }
  if (!(selectedDeployment !== null && selectedDeployment !== void 0 && selectedDeployment.deploymentId)) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "alert alert-warning"
    }, /*#__PURE__*/_react["default"].createElement("p", null, "There are no Data Collection Waves associated with ", /*#__PURE__*/_react["default"].createElement("b", null, selectedCourse.label), ".", Fortress.hasAnyAccess(['quest.admin', 'quest.deploy']) && /*#__PURE__*/_react["default"].createElement("span", null, "\xA0You can create a Data Collection Wave for ", /*#__PURE__*/_react["default"].createElement("b", null, selectedCourse.label), " in the", ' ', /*#__PURE__*/_react["default"].createElement(_cccisdReactRouter.Link, {
      to: "/quest/".concat(selectedCourse.groupId, "/deploy")
    }, "Quest"), " area.")));
  }
  var isCertificate = ((0, _get2["default"])(selectedCourse, 'settings.navigation', '') || '').includes('courseWrapper') && !!(0, _get2["default"])(selectedCourse, 'settings.navigationSettings.certificate.toggle', false);
  var tableProps = {
    name: 'licensing_courses',
    query: _progress["default"],
    graphqlVariables: {
      deploymentId: selectedDeployment.deploymentId,
      productId: selectedProduct.productId,
      roles: selectedProduct.roleList.map(function (r) {
        return r.handle;
      })
    },
    rowKey: 'pawn.pawnId',
    noRecordsMessage: 'No licensed users have started this Data Collection Wave yet',
    isStickyHeader: true,
    showDoubleScrollbar: true,
    columns: [{
      name: 'user.username',
      label: 'Username',
      filter: true,
      sort: true
    }, {
      name: 'displayName',
      label: 'Name',
      filter: true,
      sort: true
    }, {
      name: 'role.label',
      label: 'Role',
      filter: true,
      sort: true
    }, {
      name: 'parentGroup.anyGroup.group.label',
      label: 'Group',
      filter: true,
      sort: true
    }, {
      name: 'assignmentProgress.status',
      label: 'Status',
      filter: true,
      sort: true,
      filterSettings: {
        type: 'selectbox',
        placeholder: '-- Choose one --',
        options: [{
          label: 'Not started',
          value: 'Not started'
        }, {
          label: 'In Progress',
          value: 'In Progress'
        }, {
          label: 'Complete',
          value: 'Complete'
        }]
      }
    }, {
      name: 'assignmentProgress.completedAt',
      label: 'Completed',
      filter: true,
      sort: true,
      filterSettings: {
        type: 'date'
      }
    }, {
      name: 'ownedLicense.voucher.code',
      label: 'Voucher',
      filter: true,
      sort: true
    }].concat(_toConsumableArray(isCertificate ? [{
      name: 'assignmentProgress.assignmentProgressId',
      label: 'Certificate',
      className: 'text-center',
      hideInCsv: true,
      render: function render(renderProps) {
        return /*#__PURE__*/_react["default"].createElement(_Certificate["default"], _extends({}, renderProps, licensingAdminContext));
      }
    }] : []), [{
      name: 'assignmentProgress.lastVisitedAt',
      label: 'Last Visited',
      filter: true,
      sort: true,
      filterSettings: {
        type: 'date'
      }
    }, {
      name: 'licenseStatus',
      label: 'License Status',
      filter: true,
      sort: true,
      filterSettings: {
        type: 'selectbox',
        placeholder: '-- Choose one --',
        options: [{
          label: 'Active',
          value: 'Active'
        }, {
          label: 'Expired',
          value: 'Expired'
        }]
      },
      className: _style["default"].uppercase
    }, {
      name: 'ownedLicense.createdAt',
      label: 'Activated On',
      filter: true,
      sort: true,
      filterSettings: {
        type: 'date'
      }
    }, {
      name: 'ownedLicense.expiresAt',
      label: 'Expires On',
      filter: true,
      sort: true,
      filterSettings: {
        type: 'date'
      }
    }])
  };
  return /*#__PURE__*/_react["default"].createElement(_cccisdGraphqlTable["default"], tableProps);
};
var _default = exports["default"] = Courses;